const DEDICATED_AUTH_PATHS = new Set([
  '/login',
  '/register',
  '/de/login',
  '/de/registrieren',
])

/** Auth screens own the entire viewport and must never inherit marketing chrome. */
export function isDedicatedAuthPath(pathname: string): boolean {
  const normalized = pathname.replace(/\/+$/u, '') || '/'
  return DEDICATED_AUTH_PATHS.has(normalized)
}
